import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import FanchaLayout from "@/components/feature/FanchaLayout";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 反差吃瓜局",
    description: "你访问的页面不存在或已被移动，返回反差吃瓜局首页，看看最新的人设反转与前后对比深扒。",
    canonicalPath: location.pathname,
  });

  return (
    <FanchaLayout>
      <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-24 text-center">
        <div className="relative">
          <span className="font-heading text-[7rem] font-black leading-none text-primary-100 select-none">404</span>
          <span className="absolute left-1/2 top-1/2 flex h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-foreground-950 text-accent-400">
            <i className="ri-user-unfollow-line text-2xl" />
          </span>
        </div>
        <h1 className="mt-2 font-heading text-2xl font-black text-foreground-950">这条瓜，走丢啦</h1>
        <p className="mt-2 text-sm text-foreground-600">
          你访问的页面不存在或已被移动：<span className="font-mono text-foreground-500">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/#cases"
            className="whitespace-nowrap rounded-full border border-background-200 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
          >
            去看反转档案
          </Link>
        </div>
      </div>
    </FanchaLayout>
  );
}